<template>
  <el-form
    ref="personalDetails"
    :inline-message="true"
    :inline="true"
    :rules="rules"
    :model="personalDetails"
    label-width="124px"
    size="small"
    :disabled="applicationFinalSaved"
  >
    <el-form-item size="small" prop="surname" :label="$t('surname')">
      <el-input
        v-model="personalDetails.surname"
        @change="fieldChanged"
        :disabled="true"
      >
      </el-input>
    </el-form-item>
    <el-form-item prop="name" :label="$t('name')">
      <el-input
        type="text"
        v-model="personalDetails.name"
        @change="fieldChanged"
        :disabled="true"
      >
      </el-input>
      <!-- :disabled="!!personalDetails.name" -->
    </el-form-item>
    <el-form-item prop="fatherName" :label="$t('fname')">
      <el-input
        v-model="personalDetails.fatherName"
        @change="fieldChanged"
        :disabled="true"
      >
      </el-input>
    </el-form-item>
    <el-form-item prop="motherName" :label="$t('mname')">
      <el-input
        v-model="personalDetails.motherName"
        @change="fieldChanged"
        :disabled="true"
      >
      </el-input>
    </el-form-item>
    <el-form-item prop="gender" :label="$t('gender')">
      <el-select
        class="countries"
        v-model="personalDetails.gender"
        :placeholder="$t('select')"
        @change="fieldChanged"
        filterable
      >
        <el-option
          v-for="item in gender"
          :key="item.value"
          :label="$t(item.label)"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <hr />
    <el-form-item prop="birthCountryId" :label="$t('countryofbirth')">
      <el-select
        v-model="personalDetails.birthCountryId"
        @change="fieldChanged"
        :placeholder="$t('select_country')"
        class="countries"
        :class="{ 'country-inactive': birthCountryInactive }"
        filterable
      >
        <el-option
          v-for="country in countryOptions"
          :key="country.id"
          :label="country.name"
          :value="country.id"
        >
          {{
            country.name.length > 30
              ? country.name.substring(0, 28) + '...'
              : country.name
          }}
        </el-option>
      </el-select>
      <inactive-country-warning :show="birthCountryInactive" />
      <div :class="{ 'country-inactive-text': birthCountryInactive }">
        {{ longCountryName(personalDetails.birthCountryId) }}
      </div>
    </el-form-item>
    <el-form-item prop="birthCity" :label="$t('cityofbirth')">
      <el-input
        v-model="personalDetails.birthCity"
        @change="fieldChanged"
        @input="
          personalDetails.birthCity = personalDetails.birthCity.toUpperCase()
        "
      ></el-input>
    </el-form-item>
    <el-form-item prop="dateOfBirth" :label="$t('dateofbirth')">
      <el-date-picker
        id="dateOfBirth"
        v-model="personalDetails.dateOfBirth"
        type="date"
        :placeholder="$t('select_date')"
        format="dd-MM-yyyy"
        value-format="dd-MM-yyyy"
        @change="fieldChanged"
      >
      </el-date-picker>
    </el-form-item>
    <hr />
    <el-form-item prop="countryId" :label="$t('countryofresidence')">
      <el-select
        v-model="personalDetails.countryId"
        @change="fieldChanged"
        :placeholder="$t('select_country')"
        class="countries"
        :class="{ 'country-inactive': residenceCountryInactive }"
        filterable
      >
        <el-option
          v-for="country in countryOptions"
          :key="country.id"
          :label="country.name"
          :value="country.id"
        >
          {{
            country.name.length > 30
              ? country.name.substring(0, 28) + '...'
              : country.name
          }}
        </el-option>
      </el-select>
      <inactive-country-warning :show="residenceCountryInactive" />
      <div :class="{ 'country-inactive-text': residenceCountryInactive }">
        {{ longCountryName(personalDetails.countryId) }}
      </div>
    </el-form-item>
    <el-form-item prop="address" :label="$t('homeaddress')">
      <el-input
        v-model="personalDetails.address"
        @change="fieldChanged"
        @input="personalDetails.address = personalDetails.address.toUpperCase()"
      ></el-input>
    </el-form-item>
    <el-form-item prop="postcode" :label="$t('zip')">
      <el-input
        :controls="false"
        v-model="personalDetails.postcode"
        @change="fieldChanged"
      ></el-input>
    </el-form-item>
    <el-form-item prop="city" :label="$t('city')">
      <el-input
        v-model="personalDetails.city"
        @change="fieldChanged"
        @input="personalDetails.city = personalDetails.city.toUpperCase()"
      ></el-input>
    </el-form-item>
    <el-form-item prop="area" :label="$t('region')">
      <el-input
        v-model="personalDetails.area"
        @change="fieldChanged"
        @input="personalDetails.area = personalDetails.area.toUpperCase()"
      ></el-input>
    </el-form-item>
    <el-form-item prop="telephone" :label="$t('tel')">
      <el-input
        :controls="false"
        v-model="personalDetails.telephone"
        @change="fieldChanged"
      ></el-input>
    </el-form-item>
    <el-form-item prop="mobile" :label="$t('mobile')">
      <el-input
        :controls="false"
        v-model="personalDetails.mobile"
        @change="fieldChanged"
      ></el-input>
    </el-form-item>
    <el-form-item prop="email" :label="$t('email')">
      <el-input
        v-model="personalDetails.email"
        @change="fieldChanged"
      ></el-input>
    </el-form-item>
    <el-form-item prop="afm" :label="$t('afm')">
      <el-input
        v-model="personalDetails.afm"
        @change="fieldChanged"
        :disabled="true"
      >
      </el-input>
    </el-form-item>
    <!--<el-form-item label="ΔΟΥ">-->
    <!--<el-input v-model="personalDetails.doy"></el-input>-->
    <!--</el-form-item>-->
    <hr />
    <el-form-item prop="id.idCardOrPassport" :label="$t('select')">
      <el-radio-group v-model="idOrPassport" size="small" @change="idChanged">
        <el-radio-button label="idCard">{{ $t('idcard') }}</el-radio-button>
        <el-radio-button label="passport">{{ $t('passport') }}</el-radio-button>
      </el-radio-group>
    </el-form-item>
    <el-form-item
      :label="$t('idnumber')"
      prop="id.number"
      v-show="idOrPassport === 'idCard' || idOrPassport === 'passport'"
    >
      <el-input
        v-model="personalDetails.id.number"
        @change="fieldChanged"
        @input="
          personalDetails.id.number = personalDetails.id.number.toUpperCase()
        "
      >
      </el-input>
    </el-form-item>
    <el-form-item
      v-show="idOrPassport === 'idCard'"
      prop="id.issueDate"
      :label="$t('dateofissue')"
    >
      <el-date-picker
        v-model="personalDetails.id.issueDate"
        type="date"
        :placeholder="$t('select_date')"
        format="dd-MM-yyyy"
        value-format="dd-MM-yyyy"
        @change="fieldChanged"
        id="issueDate"
        :picker-options="pickerOptions"
      >
      </el-date-picker>
    </el-form-item>
    <el-form-item
      v-show="idOrPassport === 'passport'"
      prop="id.expireDate"
      :label="$t('expirationdate')"
    >
      <el-date-picker
        v-model="personalDetails.id.expireDate"
        type="date"
        :placeholder="$t('select_date')"
        format="dd-MM-yyyy"
        value-format="dd-MM-yyyy"
        @change="fieldChanged"
        id="expireDate"
      >
      </el-date-picker>
    </el-form-item>
    <el-form-item
      v-show="idOrPassport === 'idCard'"
      prop="id.issueAuthority"
      :label="$t('depofissue')"
    >
      <el-input
        v-model="personalDetails.id.issueAuthority"
        @change="fieldChanged"
        @input="
          personalDetails.id.issueAuthority = personalDetails.id.issueAuthority.toUpperCase()
        "
      >
      </el-input>
    </el-form-item>
    <el-form-item
      v-show="idOrPassport === 'passport'"
      prop="id.issueAuthority"
      :label="$t('countryofissue')"
    >
      <el-select
        v-model="personalDetails.id.issueAuthority"
        @change="fieldChanged"
        :placeholder="$t('country')"
        class="countries"
        :class="{ 'country-inactive': issueCountryInactive }"
        filterable
      >
        <el-option
          v-for="country in countryOptions"
          :key="country.id"
          :label="country.name"
          :value="country.name"
        >
          {{
            country.name.length > 30
              ? country.name.substring(0, 28) + '...'
              : country.name
          }}
        </el-option>
      </el-select>
      <inactive-country-warning :show="issueCountryInactive" />
      <div :class="{ 'country-inactive-text': issueCountryInactive }">
        {{
          personalDetails.id.issueAuthority &&
          personalDetails.id.issueAuthority.length > 30
            ? personalDetails.id.issueAuthority
            : ''
        }}
      </div>
    </el-form-item>
  </el-form>
</template>

<script>
import InactiveCountryWarning from './InactiveCountryWarning'
import {
  selectableCountries,
  findCountryById,
  isInactiveCountryId,
  isInactiveCountryName,
} from '../../utils/countries'

export default {
  components: {
    InactiveCountryWarning,
  },
  props: [
    'personalDetails',
    'countries',
    'applicationFinalSaved',
    'checkFormPD',
  ],
  mounted() {
    if (this.personalDetails.id.idCardOrPassport === null) {
      this.personalDetails.id.idCardOrPassport = true
    }
    this.clearInactiveCountries()
  },
  created() {
    this.validateTel = (rule, value, callback) => {
      if (this.formValidation) {
        if (!value) {
          return callback(new Error(this.$t('telephoneRequiredMsg')))
        }
        if (!value.match(/^[0-9]{10,20}$/)) {
          callback(new Error(this.$t('mobileValidationMsg')))
        } else {
          callback()
        }
      }
    }
  },
  data() {
    // var validateDate = (rule, value, callback) => {
    //   var CurrentDate = new Date()
    //   if (!value.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/)) {
    //     callback(new Error('Η ημερομηνία πρέπει να είναι της μορφής dd-mm-yyyy'))
    //   } else if (value < CurrentDate) {
    //     callback(new Error('Δώστε έγκυρη ημερομηνία'))
    //   } else {
    //     callback()
    //   }
    // }
    return {
      pickerOptions: {
        disabledDate(date) {
          return date > Date.now();
        }
      },
      formValidation: false,
      gender: [
        { value: 'ΑΝΤΡΑΣ', label: 'male' },
        { value: 'ΓΥΝΑΙΚΑ', label: 'female' },
        { value: 'ΑΛΛΟ', label: 'other_gender' },
      ],
      // idOrPassport: this.personalDetails.id.idCardOrPassport === null
      //   ? null : this.personalDetails.id.idCardOrPassport ? 'idCard' : 'passport',
      // numberId: this.personalDetails.id.number,
    }
  },
  methods: {
    idCardOrPassportDefault() {
      this.personalDetails.id.idCardOrPassport = true
    },
    idChanged(id) {
      this.personalDetails.id.idCardOrPassport = id === 'idCard'
      this.personalDetails.id.issueAuthority = ''
      this.formValidation ? this.checkForm() : console.log('first visit')
      this.$emit('personalDetailsChanged', this.personalDetails)
    },
    fieldChanged() {
      this.formValidation ? this.checkForm() : console.log('first visit')
      this.$emit('personalDetailsChanged', this.personalDetails)
    },
    // Full country name, shown under the select when it is too long to fit.
    longCountryName(countryId) {
      const country = findCountryById(this.countries, countryId)
      return country && country.name.length > 30 ? country.name : ''
    },
    // Editable application: clear fields holding an inactive country,
    // so the user has to select one of the active countries.
    clearInactiveCountries() {
      if (this.applicationFinalSaved || !this.personalDetails) return
      const pd = this.personalDetails
      let changed = false
      if (isInactiveCountryId(this.countries, pd.birthCountryId)) {
        pd.birthCountryId = null
        changed = true
      }
      if (isInactiveCountryId(this.countries, pd.countryId)) {
        pd.countryId = null
        changed = true
      }
      // issueAuthority holds the country name only for passports
      // (for ID cards it is the free-text issuing authority).
      if (
        this.isPassport &&
        isInactiveCountryName(this.countries, pd.id.issueAuthority)
      ) {
        pd.id.issueAuthority = ''
        changed = true
      }
      if (changed) {
        this.$emit('personalDetailsChanged', pd)
      }
    },
    checkForm() {
      this.$refs['personalDetails'].validate(valid => {
        if (valid) {
          this.pdValid = true
          this.$emit('pdValidEvent', this.pdValid)
        } else {
          this.pdValid = false
          this.$emit('pdValidEvent', this.pdValid)
        }
      })
    },
  },
  computed: {
    idPass() {
      return this.personalDetails.id.idCardOrPassport
    },
    countryOptions() {
      return selectableCountries(this.countries, this.applicationFinalSaved)
    },
    // Locked application with an inactive country: highlight and warn.
    birthCountryInactive() {
      return (
        this.applicationFinalSaved &&
        isInactiveCountryId(this.countries, this.personalDetails.birthCountryId)
      )
    },
    residenceCountryInactive() {
      return (
        this.applicationFinalSaved &&
        isInactiveCountryId(this.countries, this.personalDetails.countryId)
      )
    },
    // Same truthiness check as idOrPassport: the backend may send 0/1
    // instead of false/true; null means not chosen yet (defaults to ID card).
    isPassport() {
      const id = this.personalDetails && this.personalDetails.id
      return (
        !!id &&
        id.idCardOrPassport !== null &&
        id.idCardOrPassport !== undefined &&
        !id.idCardOrPassport
      )
    },
    issueCountryInactive() {
      return (
        this.applicationFinalSaved &&
        this.isPassport &&
        isInactiveCountryName(
          this.countries,
          this.personalDetails.id.issueAuthority
        )
      )
    },
    rules() {
      if (this.formValidation) {
        return {
          surname: [
            {
              required: true,
              message: this.$t('surnameRequiredMsg'),
              max: 100,
              trigger: 'change',
            },
          ],
          name: [
            {
              required: true,
              message: this.$t('nameRequiredMsg'),
              max: 100,
              trigger: 'change',
            },
          ],
          dateOfBirth: [
            {
              required: true,
              message: this.$t('birthDateRequiredMsg'),
              max: 100,
              trigger: 'change',
            },
          ],
          fatherName: [
            {
              required: true,
              message: this.$t('fatherNameRequiredMsg'),
              max: 100,
              trigger: 'change',
            },
          ],
          email: [
            {
              required: true,
              message: this.$t('emailRequiredMsg'),
              trigger: 'change',
            },
            {
              type: 'email',
              max: 100,
              message: this.$t('emailValidationMsg'),
            },
          ],
          mobile: [
            {
              required: true,
              message: this.$t('mobileRequiredMsg'),
              trigger: 'change',
            },
            {
              min: 10,
              max: 20,
              message: this.$t('numberValidationMsg'),
              triger: 'change',
            },
          ],
          telephone: [
            {
              required: false,
              min: 10,
              max: 20,
              message: this.$t('numberValidationMsg'),
              triger: 'change',
            },
          ],
          city: [
            {
              required: true,
              max: 100,
              message: this.$t('cityRequiredMsg'),
              trigger: 'change',
            },
          ],
          postcode: [
            {
              required: true,
              message: this.$t('zipCodeValidationMsg'),
              min: 2,
              max: 16,
              trigger: 'change',
            },
          ],
          address: [
            {
              required: true,
              max: 100,
              message: this.$t('addressRequiredMsg'),
              trigger: 'change',
            },
          ],
          birthCountryId: [
            {
              required: true,
              message: this.$t('birthCountryRequiredMsg'),
              trigger: 'change',
            },
          ],
          countryId: [
            {
              required: true,
              message: this.$t('residenceCountryRequiredMsg'),
              trigger: 'change',
            },
          ],
          gender: [
            {
              required: true,
              max: 100,
              message: this.$t('genderRequiredMsg'),
              trigger: 'change',
            },
          ],
          // 'id.idCardOrPassport': [{ required: true, message: 'Παρακαλώ επιλέξτε έγγραφο ταυτοποίησης', trigger: 'change', max: 100 }],
          'id.number': [
            {
              required: true,
              max: 100,
              message: this.$t('idNumberRequiredMsg'),
              trigger: 'change',
            },
          ],
          'id.issueDate': [
            {
              required: this.idPass,
              max: 100,
              message: this.$t('issueDateRequiredMsg'),
              trigger: 'change',
            },
          ],
          'id.issueAuthority': [
            {
              required: true,
              max: 100,
              message: this.$t('issueAuthorityRequiredMsg'),
              trigger: 'change',
            },
          ],
          'id.expireDate': [
            {
              required: !this.idPass,
              max: 100,
              message: this.$t('expirationDateRequiredMsg'),
              trigger: 'change',
            },
          ],
        }
      } else {
        return null
      }
    },
    idOrPassport: {
      get: function() {
        if (this.personalDetails.id.idCardOrPassport === null) {
          this.idCardOrPassportDefault()
          return 'idCard'
        } else {
          return this.personalDetails.id.idCardOrPassport
            ? 'idCard'
            : 'passport'
        }
      },
      set: function(val) {
        this.idChanged(val)
      },
    },
  },
  watch: {
    checkFormPD: function(newData, oldData) {
      this.formValidation = true
      this.checkForm()
    },
    countries: 'clearInactiveCountries',
    applicationFinalSaved: 'clearInactiveCountries',
    personalDetails: 'clearInactiveCountries',
  },
}
</script>

<style scoped lang="scss">
@import '../../styles/variables.scss';

.el-select {
  &.countries {
    width: 240px;
  }
}
.el-input {
  width: 240px;
}
hr {
  border-color: #7da0b8;
}
@media only screen and (max-width: $screen-sm-min) {
  .hideSMdown {
    display: none;
  }
}
</style>
